import CustomerGroupDetail from './CustomerGroupDetail';

export default CustomerGroupDetail;



// WEBPACK FOOTER //
// ./src/scenes/CustomerGroup/CustomerGroupDetail/index.ts